import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { Controller, RegisterOptions } from 'react-hook-form';

export interface Option {
    key: string,
    label: string
}

interface Props {
    id?: string,
    name: string,
    label: string,
    options: Option[],
    registerOptions?: RegisterOptions<any, any>
}

const SHAutocomplete : React.FC<Props> = ({id, name, label, options, registerOptions}) => {
    return <Controller name={name} rules={registerOptions} render={({fieldState, field}) => <>
    <Autocomplete 
        {...field}
        sx={{width: '100%'}} 
        options={options}
        renderInput={(params) => <TextField 
            {...params} 
            label={label}
            name={field.name}  
            />}
        onChange={(_, value) => field.onChange(value)}
        getOptionKey={(o) => (o as Option)?.key??""}
        getOptionLabel={(o) => (o as Option)?.label??""}
     />
    </>} />;
}

export default SHAutocomplete;